import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64d84cce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "claim-countdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mint ends", -1))
const _hoisted_3 = { class: "claim-countdown-timer" }

import { onBeforeMount, ref } from 'vue';
import { getCountdownFromTimestamp } from '@manifoldxyz/dropsite-lib';

interface CountdownProps {
  endDate: Date;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Countdown',
  props: {
    endDate: {}
  },
  setup(__props: any) {

const props = __props;



const countdown = ref<any>({
  days: '',
  hours: '',
  minutes: '',
  seconds: ''
});

const countdownInterval = () => {
  requestAnimationFrame(countdownInterval);
  countdown.value = getCountdownFromTimestamp(props.endDate, true, false);
};

onBeforeMount(() => {
  countdownInterval();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(countdown.value.days) + "d", 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(countdown.value.hours) + "h", 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(countdown.value.minutes) + "m", 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", null, _toDisplayString(countdown.value.seconds) + "s", 1)
      ])
    ])
  ]))
}
}

})